const ACTION = '@auth/'

export const ACTIONS = {
  SIGN_IN_REQUEST: ACTION + 'SIGN_IN_REQUEST',
  SIGN_IN_REQUEST_SUCCESS: ACTION + 'SIGN_IN_REQUEST_SUCCESS',
  SIGN_IN_REQUEST_FAILURE: ACTION + 'SIGN_IN_REQUEST_FAILURE',
  SIGN_OUT_REQUEST: ACTION + 'SIGN_OUT_REQUEST',
  SIGN_IN_REJECTION: ACTION + 'SIGN_IN_REJECTION',
  PASSWORD_RESET_REQUEST: ACTION + 'PASSWORD_RESET_REQUEST',
  ACTION_REQUEST: ACTION + 'ACTION_REQUEST',
  ACTION_REQUEST_SUCCESS: ACTION + 'ACTION_REQUEST_SUCCESS',
  ACTION_REQUEST_FAILURE: ACTION + 'ACTION_REQUEST_FAILURE',
}

export function signInRequest(payload) {
  return {
    type: ACTIONS.SIGN_IN_REQUEST,
    payload: { ...payload },
  }
}

export function signInRequestSuccess(token, refresh, user) {
  return {
    type: ACTIONS.SIGN_IN_REQUEST_SUCCESS,
    payload: { token, refresh, user },
  }
}

export function signInRequestFailure(data) {
  return {
    type: ACTIONS.SIGN_IN_REQUEST_FAILURE,
    payload: { data },
  }
}

export function signInRejection() {
  return {
    type: ACTIONS.SIGN_IN_REJECTION,
  }
}

export function signOutRequest() {
  return {
    type: ACTIONS.SIGN_OUT_REQUEST,
  }
}

export function passwordResetRequest(email) {
  return {
    type: ACTIONS.PASSWORD_RESET_REQUEST,
    payload: { email },
  }
}

export function actionRequestSuccess(data) {
  return {
    type: ACTIONS.ACTION_REQUEST_SUCCESS,
    payload: { data },
  }
}

export function actionRequestFailure(data) {
  return {
    type: ACTIONS.ACTION_REQUEST_FAILURE,
    payload: { data },
  }
}

export function signOut() {
  return {
    type: '@auth/SIGN_OUT',
  }
}
